import React, { useEffect, useState } from "react";
import { CloseButton } from "react-bootstrap";
import { useModal } from "../../Context/ModalContext";
import { useAppDispatch, useAppSelector } from "../../hook/redux";
import { getBackgroundStyle } from "../Toolbar/LayoutEditor/Components/LayoutSelector";

function LayoutSelectorModal() {
  const { loadInPageMultimgEditor, selectedLayout, selectedBackground, layouts } = useAppSelector((state) => state.editor);
  const orientation = useAppSelector( ( state ) => state.editor.loadInPageMultimgEditor.orient );

  const [backgroundWithOrientation, setBackgroundWithOrientation] = useState(selectedBackground[ orientation ]);

  const { show, toggleShow, type } = useModal();

  const dispatch = useAppDispatch();

  const LI_STYLE: React.CSSProperties = {
    width: loadInPageMultimgEditor.orient === "h" || loadInPageMultimgEditor.orient === "s" ? "106px" : "76px",
    height: loadInPageMultimgEditor.orient === "h" ? "76px" : "106px",
    cursor: "pointer",
    backgroundImage: `url(${process.env.PREFIX_URL}${backgroundWithOrientation})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  /**
   * Handles the change of the selected layout in the editor.
   * @param {number} id - The ID of the new layout to be selected.
   */
  const handleChangeLayout = (id: number) => {
    dispatch({
      type: "editor/updateSelectedLayout",
      payload: id,
    });
  };

  /**
   * Handles the background click event for a component.
   *
   * This function checks if the click event's target is the same as its current target
   * (indicating a click outside of child elements) and triggers a callback to toggle a state.
   *
   * @param {React.MouseEvent} e - The mouse event triggered by user interaction on the background.
   */
  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      toggleShow(false, null, type);
    }
  };

  useEffect(() => {
    setBackgroundWithOrientation(selectedBackground[ orientation ]);
  }, [selectedBackground, orientation]);

  return (
    <div
      className={`custom-modal-background ${show && type === "layout" ? "" : "hidden"}`}
      onClick={handleBackgroundClick}
    >
      <div
        className={`custom-modal ${show && type === "layout" ? "" : "hidden"}`}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h4 className="custom-modal-title">Changer de mise en page</h4>
            <CloseButton
              onClick={ () => toggleShow( false, null, type ) }
              aria-label="Close"
            />
          </div>
          <div className="custom-modal-body">
            <div className="custom-modal-flex">
              { layouts.map( ( layout, index ) => (
                <div key={ index }
                     style={ { ...LI_STYLE, position: "relative" } }
                     onClick={ () => {handleChangeLayout( layout.id ), toggleShow( false, null, type );} }
                     data-test={ `layout-card` }>
                  <img
                    style={{
                      ...getBackgroundStyle(backgroundWithOrientation),
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain"
                    }}

                    src={ `${process.env.PREFIX_URL}/v2017/layout-carte-prevu/${ loadInPageMultimgEditor.orient }/${ layout.id }_small.gif` }
                  />
                  { selectedLayout === layout.id && (
                    <img
                      style={ {
                        position: "absolute",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        border:
                          selectedLayout === layout.id
                          ? "2px solid #4498E0"
                          : "none"
                      } }
                      src={ `${process.env.PREFIX_URL}/v2017/img/layout-selected-${ loadInPageMultimgEditor.orient }.png` }
                    />
                  ) }
                </div>
              ) ) }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LayoutSelectorModal;
